import { Chip as MUIChip } from '@mui/material';

/**
 * Project alias for MUI's Chip. Import from here instead of `@mui/material`;
 * all MUI Chip props pass through. Note an identical pass-through also exists
 * at `common/components/Chip` — the two are interchangeable duplicates.
 */
const Chip = props => <MUIChip {...props} />;

export default Chip;
